import { Button } from '@mui/material'
import { useState, type JSX } from 'react'
import { useTranslation } from 'react-i18next'

const ReportMenu = (): JSX.Element => {
  const { t } = useTranslation()
  // const menuStyle = { textDecoration: 'none' }
  const [anchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  return (
    <div>
      <Button
        id="btnReport"
        aria-controls={open ? 'user-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        href="/reports"
      >
        {t('menus.report.title')}
      </Button>
    </div>
  )
}

export default ReportMenu
